import { createSelector } from 'reselect';
import buildPropertyCardsData from 'lib/search/buildPropertyCardsData';
import { getResults } from './searchSelectors';

export const getPropertyCardsData = createSelector(getResults, (results) => buildPropertyCardsData({ results, imageSrcSize: 'urlMedium' }));
